<mat-card>
    <mat-card-header>
      <mat-card-title>Relationship Details</mat-card-title>
    </mat-card-header>
<mat-card-content class="m-t-1">
    <div class="content-container">
     
             <app-select-input label="What is the applicant's relationship status with the sponsor?"
                [control]="relationshipPartnerForm.controls.status"
                [options]="relationStatuses" shortLabel="Relationship Status"
                [placeholder]="'Select a relationship status'"
                [useStringValue]="true">
            </app-select-input>
  
@if(showMetInPerson) {

    <app-radio-input [label]="'Have you met each other in person?'" shortLabel="Met in Person"
        [control]="relationshipPartnerForm.controls.metInPerson"
        [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
    </app-radio-input>

}
@if(showFirstMet) {
    <app-date-input [label]="'What date did you first meet?'" shortLabel="First Met"
        [control]="relationshipPartnerForm.controls.firstMet">
    </app-date-input>
}

<app-date-input [label]="'When did your relationship commence?'" shortLabel="Relationship Commence"
        [control]="relationshipPartnerForm.controls.relationshipStart">  
</app-date-input>

@if(showDateMarried) {
    <app-date-input [label]="'What date were you married?'" shortLabel="Date Married"
        [control]="relationshipPartnerForm.controls.dateMarried">
    </app-date-input>
}
@if(showIntendToMarry) {
   <app-radio-input [label]="'Do you plan to get married?'" shortLabel="Intend to Marry"
        [control]="relationshipPartnerForm.controls.intendToMarry"
        [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
    </app-radio-input>

}

@if(showDatePlannedMarriage) {
    <app-date-input [label]="'When do you plan to get married?'" shortLabel="Planned Marriage Date"
        [control]="relationshipPartnerForm.controls.datePlannedMarriage">
    </app-date-input>
}
@if(showLiveTogether) {
    <app-radio-input [label]="'Are you currently living together?'" shortLabel="Living Together"
        [control]="relationshipPartnerForm.controls.liveTogether"      
        [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
    </app-radio-input>
    @if(showStartedLivingTogether) {
        <app-date-input [label]="'What date did you start living together?'" shortLabel="Started Living Together"
            [control]="relationshipPartnerForm.controls.startedLivingTogether">
        </app-date-input>
    }
}

@if(showHaveChildren) {
    <app-radio-input
    [label]="'Have you had any children together?'" shortLabel="Have Children"
    [control]="relationshipPartnerForm.controls.haveChildren"
    [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
    </app-radio-input>
}

@if(showNumChildren) {
    <app-text-input [label]="'How many children have you had together?'" type="number" shortLabel="Number of Children"
        [control]="relationshipPartnerForm.controls.numChildren" type="number" [errorMsg]="'Numbers Only'">
    </app-text-input>
}


    </div>
</mat-card-content>
</mat-card>